import { render, staticRenderFns } from "./ButtonMainDialog.vue?vue&type=template&id=f1b3341e&scoped=true&"
import script from "./ButtonMainDialog.vue?vue&type=script&lang=js&"
export * from "./ButtonMainDialog.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMainDialog.vue?vue&type=style&index=0&id=f1b3341e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b3341e",
  null
  
)

export default component.exports